"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GeolocationServiceClient_1 = __importDefault(require("./GeolocationServiceClient"));
exports.default = GeolocationServiceClient_1.default;
var UnableToFetchIpInfoError_1 = require("./errors/UnableToFetchIpInfoError");
exports.UnableToFetchIpInfoError = UnableToFetchIpInfoError_1.default;
